import { render } from "./AppHeaderMenuBlock.vue?vue&type=template&id=0f60ea8e&scoped=true"
import script from "./AppHeaderMenuBlock.vue?vue&type=script&lang=js"
export * from "./AppHeaderMenuBlock.vue?vue&type=script&lang=js"

import "./AppHeaderMenuBlock.vue?vue&type=style&index=0&id=0f60ea8e&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f60ea8e"]])

export default __exports__